module.exports = __webpack_public_path__ + "img/smoke-fast.54602dfc.png";